export default __webpack_public_path__ + "static/media/facebook.6f6cafa1.svg";